module.exports = __webpack_public_path__ + "assets/img/user2.ac4c83fb.jpg";